import { createSelector, } from 'reselect';
import { propOr, prop, } from 'ramda';
import { PLAYER_HAND, DEALER_HAND, COMMUNITY_HAND, } from '../../constants/strings';

export const cardsSelector = prop('cards');

export const playerCardsSelector = createSelector(
  cardsSelector,
  propOr({}, PLAYER_HAND)
);

export const dealerCardsSelector = createSelector(
  cardsSelector,
  propOr({}, DEALER_HAND)
);

export const communityCardsSelector = createSelector(
  cardsSelector,
  propOr({}, COMMUNITY_HAND)
);
